import i18n from '@/locale'
import service from '@/service'
import isEmpty from 'lodash/isEmpty'

const state = {
  lang: 'pl',
  dicts: {
    en: {},
    pl: {},
    cs: {}
  },
  links: {
    regulations: {
      en: 'https://delayfix.com/en/regulations/',
      pl: 'https://delayfix.com/pl/regulamin/',
      cs: 'https://delayfix.com/en/regulations/',
      ru: 'https://delayfix.com/en/regulations/',
      de: 'https://delayfix.com/en/regulations/',
      ua: 'https://delayfix.com/en/regulations/'
    },
    privacyPolicy: {
      en: 'https://delayfix.com/en/privacy-policy/',
      pl: 'https://delayfix.com/pl/polityka-prywatnosci/',
      cs: 'https://delayfix.com/en/privacy-policy/',
      ru: 'https://delayfix.com/en/privacy-policy/',
      de: 'https://delayfix.com/en/privacy-policy/',
      ua: 'https://delayfix.com/en/privacy-policy/'
    }
  }
}

const mutations = {
  setLanguage(state, lang) {
    state.lang = lang
    i18n.locale = lang
  },
  setDictionary(state, { data, lang }) {
    state.dicts[lang] = data
  }
}

const actions = {
  setLanguage({ state, commit }, lang) {
    commit('setLanguage', lang)
    if (!isEmpty(state.dicts[lang])) return
    const langsNotInApi = []
    const tmpLang = langsNotInApi.includes(lang) ? 'en' : lang
    service.fields.all(tmpLang).then(response => {
      commit('setDictionary', { data: response.data, lang })
    })
  }
}

const getters = {
  isActiveLang(state) {
    return lang => state.lang === lang
  },
  getLang(state) {
    return state.lang
  }
}

export default {
  actions,
  mutations,
  state,
  getters
}
